import React from 'react';
import initialMetricsPublisher from '../metrics';
import up_right_arrow from 'src/images/icon/up_right_arrow.png';

interface SubmitDealershipFormButtonProps {
    consentConfirmed: boolean;
    onConsentChange: (checked: boolean) => void;
    onSubmit: (e: React.FormEvent) => void;
    isFormValid: boolean;
    isSubmitting?: boolean;
    consentMessage?: string;
    warningMessage?: string;
    buttonText?: string;
    recordMetric?: boolean;
    errorMessage?: string;
}

const SubmitDealershipFormButton: React.FC<SubmitDealershipFormButtonProps> = ({
                                                                                   consentConfirmed,
                                                                                   onConsentChange,
                                                                                   onSubmit,
                                                                                   isFormValid,
                                                                                   isSubmitting = false,
                                                                                   consentMessage,
                                                                                   warningMessage,
                                                                                   buttonText,
                                                                                   recordMetric,
                                                                                   errorMessage = ''
                                                                               }) => {
    return (
        <form onSubmit={onSubmit}>
            <div className="form-field-full">
                <div className="consent-checkbox-label">
                    <input
                        type="checkbox"
                        name="consentConfirmed"
                        checked={consentConfirmed}
                        onChange={(e) => onConsentChange(e.target.checked)}
                    />
                    <span>{consentMessage}</span>
                </div>
            </div>

            {isFormValid && warningMessage && (
                <div className="submit-warning">
                    {warningMessage}
                </div>
            )}

            <button
                type="submit"
                className={`submit-button ${!isFormValid || isSubmitting ? 'disabled' : ''}`}
                disabled={!isFormValid || isSubmitting}
                onClick={() => {
                    if (isFormValid && recordMetric) {
                        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('FormSubmit');
                        actionMetricsPublisher.publishCounterMonitor('FormSubmittedSuccessfullyCount', 1);
                    }
                }}
            >
                {isSubmitting ? (
                    <span className="button-content">
                        <span className="spinner"></span>
                        Submitting...
                    </span>
                ) : (
                    buttonText
                )}
            </button>

            {isFormValid && errorMessage && (
                <div className="submit-error">
                    {errorMessage}
                </div>
            )}
        </form>
    );
};

export default SubmitDealershipFormButton;